import { PropsWithChildren, useEffect, useState } from 'react';

import Breadcrumbs, { BreadcrumbsProps } from '../Breadcrumbs';
import { BreadcrumbItemProps } from '../Breadcrumbs/BreadcrumbItem';
export { default as BreadcrumbIconButton } from './components/BreadcrumbIconButton';

import DropDownBreadcrumbWrapper, { ArrowWrapper, BreadcrumbsContainer } from './Wrapper';
import DropDownList from './components/DropDownList';
import { renderItemWrapper } from './helpers';
import { useBreadcrumbList } from './hooks';

export type DropDownBreadcrumbProps<T> = BreadcrumbsProps<T> & {
  className?: string;
};

const DropDownBreadcrumb = <T extends BreadcrumbItemProps>({
  data,
  className,
  renderItem,
  ...otherProps
}: PropsWithChildren<DropDownBreadcrumbProps<T>>) => {
  const [dropdownList, breadcrumbList, containerRef, breadcrumbsRef, containerMaxWidth] = useBreadcrumbList<T>(data);

  const [freeSpace, setFreeSpace] = useState<number>(0);

  useEffect(() => {
    if (!containerRef.current?.offsetWidth || !breadcrumbsRef.current?.offsetWidth) return;

    const totalWidth = containerRef.current.offsetWidth;
    const currentWidth = breadcrumbsRef.current.offsetWidth;

    setFreeSpace(totalWidth - currentWidth);
  }, [containerRef.current?.offsetWidth, breadcrumbsRef.current?.offsetWidth]);

  return (
    <DropDownBreadcrumbWrapper isArrow={!!dropdownList}>
      {dropdownList && (
        <>
          <DropDownList<T> data={dropdownList} {...otherProps} />
          <ArrowWrapper />
        </>
      )}
      <BreadcrumbsContainer ref={containerRef} maxWidth={containerMaxWidth} className={className}>
        <Breadcrumbs
          ref={breadcrumbsRef}
          data={breadcrumbList}
          renderItem={renderItemWrapper(!!dropdownList, renderItem)}
          {...otherProps}
          freeSpace={freeSpace}
        />
      </BreadcrumbsContainer>
    </DropDownBreadcrumbWrapper>
  );
};

export default DropDownBreadcrumb;
